import React, { useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";
import {
  createStyles,
  DialogActions,
  DialogContent,
  makeStyles,
  Typography,
} from "@material-ui/core";
import "jspdf-autotable";

import { CustomTheme } from "../../../../types/customTheme";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { getLayout, saveLayout } from "../../../../services/insightApp/metrics";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import { SUCCESSFULLY_CREATED } from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";

export interface DashboardCreateModalProps {
  open: any;
  setOpen: any;
  setIsOpenDashboardWidgetModal: any;
  dashboardName: any;
  setDashboardName: any;
  setLayoutDetails: any;
  setWidgetId: any;
}

const useStyles = makeStyles((theme: CustomTheme) => createStyles({}));

const DashboardCreateModal: React.FunctionComponent<
  DashboardCreateModalProps
> = ({
  open,
  setOpen,
  setIsOpenDashboardWidgetModal,
  dashboardName,
  setDashboardName,
  setLayoutDetails,
  setWidgetId,
}) => {
  const [errorDashboardName, setErrorDashboardName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const match: any = useRouteMatch();
  const locationId = match?.params?.locationId;

  const getLayoutInfo = async () => {
    try {
      // Retrieve the idToken from cookies
      // Fetch all locations using the idToken
      const res = await getLayout(locationId);
      setLayoutDetails(res.data.data);
      setIsLoading(false);
      setOpen(false);
      setIsOpenDashboardWidgetModal(true);
      //   if (res?.data?.data?.clientId) {
      //     const clientIdFromApi = res.data.data.clientId;
      //     setClientId(clientIdFromApi);
      //   }
    } catch (error) {}
  };

  const saveLayoutToFirebase = async () => {
    const data = {
      name: dashboardName,
    };
    try {
      const res = await saveLayout(locationId, data);
      setWidgetId(Object.keys(res.data.data)[0]);
      setSuccess(SUCCESSFULLY_CREATED);
      getLayoutInfo();
    } catch (error) {
      setIsLoading(false);
      console.error("Error saving layout:", error);
    }
  };

  const handleClick = () => {
    if (!dashboardName) {
      setErrorDashboardName("Please enter a dashboard name.");
    } else {
      setIsLoading(true);
      saveLayoutToFirebase();
    }
  };

  const classes: any = useStyles();

  return (
    <>
      <DialogCommonDefault
        open={open}
        setOpen={setOpen}
        maxWidth={"xs"}
        isNeedFixedHeight={false}
      >
        <DialogContent>
          <Typography variant="h6" style={{marginBottom: "12px"}}>
            Enter New Dashboard Name
          </Typography>
          <TextfieldDefault
            id="sign-email-input"
            name="sign-email-input"
            style={{ width: "100%" }}
            label="Dashboard Name"
            onChange={(e: any) => {
              setErrorDashboardName("");
              setDashboardName(e.target.value);
            }}
            value={dashboardName}
            type="text"
          />
          {errorDashboardName && (
            <ValidationMessage message={errorDashboardName} />
          )}
        </DialogContent>
        <DialogActions style={{ marginBottom: "12px", marginRight: "12px" }}>
          <ButtonCommon
            style={{ width: "120px" }}
            onClick={() => {
              setOpen(false);
              setDashboardName("");
            }}
          >
            Cancel
          </ButtonCommon>
          <ButtonCommon
            style={{ width: "120px" }}
            onClick={handleClick}
            isLoadingPage={isLoading}
            color="green"
          >
            Save
          </ButtonCommon>
        </DialogActions>
      </DialogCommonDefault>
      <DefaultAlert
        open={!!success}
        handleClose={() => setSuccess("")}
        message={success}
        severity={"success"}
      />

      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default DashboardCreateModal;
